"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserRedeemableNftOwnershipsResponseToJSON = exports.GetUserRedeemableNftOwnershipsResponseFromJSONTyped = exports.GetUserRedeemableNftOwnershipsResponseFromJSON = void 0;
var _1 = require("./");
function GetUserRedeemableNftOwnershipsResponseFromJSON(json) {
    return GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json, false);
}
exports.GetUserRedeemableNftOwnershipsResponseFromJSON = GetUserRedeemableNftOwnershipsResponseFromJSON;
function GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lootboxes': (json['lootboxes'].map(_1.NftOwnershipFromJSON)),
        'xpMultipliers': (json['xpMultipliers'].map(_1.NftOwnershipFromJSON)),
        'xpMultiplierNftTrackerId': json['xpMultiplierNftTrackerId'],
    };
}
exports.GetUserRedeemableNftOwnershipsResponseFromJSONTyped = GetUserRedeemableNftOwnershipsResponseFromJSONTyped;
function GetUserRedeemableNftOwnershipsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lootboxes': (value.lootboxes.map(_1.NftOwnershipToJSON)),
        'xpMultipliers': (value.xpMultipliers.map(_1.NftOwnershipToJSON)),
        'xpMultiplierNftTrackerId': value.xpMultiplierNftTrackerId,
    };
}
exports.GetUserRedeemableNftOwnershipsResponseToJSON = GetUserRedeemableNftOwnershipsResponseToJSON;
